import getListingCategory from './getListingCategory';
export default getListingCategory;